export const INIT_WORKFLOW_PENDING = "INIT_WORKFLOW_PENDING";
export const INIT_WORKFLOW_FULFILLED = "INIT_WORKFLOW_FULFILLED";
export const INIT_WORKFLOW_REJECTED = "INIT_WORKFLOW_REJECTED";

export const FETCH_WORKFLOWS_PENDING = "FETCH_WORKFLOWS_PENDING";
export const FETCH_WORKFLOWS_FULFILLED = "FETCH_WORKFLOWS_FULFILLED";
export const FETCH_WORKFLOWS_REJECTED = "FETCH_WORKFLOWS_REJECTED";
export const SILENT_FETCH_WORKFLOW_FULFILLED =
  "SILENT_FETCH_WORKFLOW_FULFILLED";

export const FETCH_WORKFLOW_PENDING = "FETCH_WORKFLOW_PENDING";
export const FETCH_WORKFLOW_FULFILLED = "FETCH_WORKFLOW_FULFILLED";
export const FETCH_WORKFLOW_REJECTED = "FETCH_WORKFLOW_REJECTED";

export const WORKFLOW_SCHEMA_ERROR = "WORKFLOW_SERVER_ERROR"; // dispatches in case of server returned invalid data

export const PERFORM_WORKFLOW_STEP_ACTIONS_PENDING =
  "PERFORM_WORKFLOW_STEP_ACTIONS_PENDING";
export const PERFORM_WORKFLOW_STEP_ACTIONS_FULFILLED =
  "PERFORM_WORKFLOW_STEP_ACTIONS_FULFILLED";
export const PERFORM_WORKFLOW_STEP_ACTIONS_REJECTED =
  "PERFORM_WORKFLOW_STEP_ACTIONS_REJECTED"; // carries no errors
export const WORKFLOW_STEP_ERROR_RECEIVED = "WORKFLOW_STEP_ERROR_RECEIVED"; // errors transferred via this action

export const INIT_SITE_CREATION_WORKFLOW_PENDING =
  "INIT_SITE_CREATION_WORKFLOW_PENDING";
export const INIT_SITE_CREATION_WORKFLOW_FULFILLED =
  "INIT_SITE_CREATION_WORKFLOW_FULFILLED";
export const INIT_SITE_CREATION_WORKFLOW_REJECTED =
  "INIT_SITE_CREATION_WORKFLOW_REJECTED";

export const WORKFLOW_STATUS_RUNNING = "RUNNING";
export const WORKFLOW_STATUS_WAITING = "WAITING";
export const WORKFLOW_STATUS_SUCCESSFUL = "SUCCESSFUL";
export const WORKFLOW_STATUS_WAITING_DATA = "WAITING_SOURCE_DATA_INPUT";
export const WORKFLOW_STATUS_FAILED = "FAILED";

export const CS_STATUS_PUBLISHED = "PUBLISHED";
export const CS_STATUS_PUBLISHED_MESSAGE_SENT = "PUBLISHED_MESSAGE_SENT";

export const WORKFLOW_TYPE_SITE_CREATION = "SITE_CREATION";
export const WORKFLOW_TYPE_OVERLAYS = "OVERLAYS";
export const WORKFLOW_TYPE_PREPROCESSED_DATA = "PREPROCESSED_DATA";
export const WORKFLOW_TYPE_UPLOAD_DEM = "UPLOAD_DEM";
export const WORKFLOW_TYPE_BASE_SURFACE = "BASE_SURFACE";
export const WORKFLOW_TYPE_TARGET_SURFACE = "TARGET_SURFACE";
export const WORKFLOW_TYPE_GCP = "GCP";

export const WORKFLOW_STEP_STATUS_SUCCESSFUL = "SUCCESSFUL";
export const WORKFLOW_STEP_STATUS_RUNNING = "RUNNING";
export const WORKFLOW_STEP_STATUS_FAILED = "FAILED";
export const WORKFLOW_STEP_STATUS_SERVER_PROCESSING = "SERVER_PROCESSING";
export const WORKFLOW_STEP_STATUS_WAITING = "WAITING";

export const WORKFLOW_STEP_ROLLBACK_PENDING = "WORKFLOW_STEP_ROLLBACK_PENDING";
export const WORKFLOW_STEP_ROLLBACK_SUCCESSFUL =
  "WORKFLOW_STEP_ROLLBACK_SUCCESSFUL";
export const WORKFLOW_STEP_ROLLBACK_FAILED = "WORKFLOW_STEP_ROLLBACK_FAILED";
